export const scoutCompanies = [
    {
        name: "탤런트엑스",
        registrationNumber: "1448108413",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "백엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "풀스택 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "데이터 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "UI/UX 디자이너",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
            ],
            description:
                "팀원 각자의 개성을 존중하며 다른 의견을 오히려 경청합니다. 자극적인 현상 보다는 오랫동안 변치 않을 본질에 집중하며 미니멀리즘을 추구합니다. 자신을 사랑하며 타인을 돕는데도 인색하지 않고 청년 취업과 같은 사회 문제를 해결하는 것에 관심이 많습니다. 늘 부유하고 안락한 미래를 꿈꾸지만 노력 없는 결과를 욕망하지 않습니다. 그대신 기민하게 우리 스스로부터 먼저 변화시켜 내일을 새롭게 만드는, 그래서 지금보다는 앞으로가 더욱 기대되는, 우리는 탤런트엑스 팀입니다.",
        },
        devStyles: [
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "디자인 씽킹", description: "" },
            { name: "데일리 스크럼", description: "" },
            { name: "스프린트", description: "" },
            { name: "그로스 해킹", description: "" },
        ],
        welfares: [
            { name: "최고급 역세권 선정릉뷰 WeWork 오피스 제공", image: null },
            { name: "시즌별 팀 리프레시 휴가 제공", image: null },
            { name: "탄생일 유급휴가 제공", image: null },
            { name: "Apple MacBook Pro + 모니터 제공", image: null },
            { name: "삼성 웰스토리 점심 제공", image: null },
            {
                name: "폴바셋 커피, 달차, 제로 코크, 무지방 우유 제공",
                image: null,
            },
        ],
    },
    {
        name: "지속가능발전소",
        registrationNumber: "1058802387",
        devTeam: {
            positions: [
                {
                    name: "머신러닝 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 2,
                    senior: 2,
                    leader: 0,
                },
                {
                    name: "데이터 분석가",
                    total: 4,
                    rookie: 0,
                    junior: 2,
                    senior: 2,
                    leader: 0,
                },
                {
                    name: "자연어처리 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 2,
                    senior: 2,
                    leader: 0,
                },
            ],
            description:
                "지속가능발전소 데이터팀은 AI를 활용하여 금융 정보와 뉴스를 분석하고 자동화하는 업무를 하고 있습니다. 한명의 멤버가 하나의 프로덕트를 주도적으로 리딩하며, 개발팀 멤버 뿐만 아니라 ESG 애널리스트들과 활발하게 협업합니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "격주 데이터팀 미팅", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
        ],
        welfares: [
            { name: "개발장비 지원", image: null },
            { name: "건강검진 지원", image: null },
            { name: "간식 제공", image: null },
            {
                name: "내일채움공제",
                image: null,
            },
            { name: "도서 구입비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            {
                name: "금요일 개인 업무 상황에 따라 1.5시간 조기 퇴근",
                image: null,
            },
        ],
    },
    {
        name: "(주)아키드로우",
        registrationNumber: "2618121220",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 5,
                    rookie: 0,
                    junior: 4,
                    senior: 1,
                    leader: 0,
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 5,
                    rookie: 0,
                    junior: 3,
                    senior: 2,
                    leader: 0,
                },
                {
                    name: "머신러닝 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 0,
                    senior: 2,
                    leader: 0,
                },
            ],
            description:
                "아키드로우의 개발팀은 맹목적으로 개발에 몰두하기 보다는, 소비자를 위한 제품을 만드는 일에 집중합니다.\n\n그래서 각 팀은 부합하는 원칙을 구성하고, 매 iteration마다 이를 고민하며 개발을 진행합니다. 개개인의 실력 향상을 전폭적으로 지원하며, 이를 위한 노력을 끊임없이 하고자 합니다. 또한 다양한 시도는 회사내 긍정적인 바람을 만들어 줄수 있다고 믿습니다. 그래서 누구나 아이디어만 있다면 프로젝트를 만들고 진행할 수 있습니다.\n\n개발 주기는 주당 배포를 원칙으로 합니다. 타운홀 미팅을 통해 제품 개발 진행 시 아쉬웠던 점(코드 품질, 새로운 기술 도입 등등), 소비자 피드백, 서비스 아이디어 등을 자유롭게 논의합니다. 차주의 배포 리스트는 각 팀의 원칙에 의한 논의를 통해 정합니다.\n\n저희는 소스 코드 저장소를 [Gitflow]에 따라 운영합니다. 프로덕션 소스의 안정성과 자유로운 개발 및 원활한 코드 리뷰를 위해 실제 배포용 저장소를 분리하고 개인별 저장소에서의 개발을 원칙으로 하며, Pull request를 통해 코드 통합과 배포를 진행합니다.\n\nCode merge는 만장일치로 진행됩니다. 권한자의 개인의 판단이 아니라, 모두가 인정한 '좋은 코드'를 사용하려 노력합니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "주간회의", description: "" },
            { name: "월간회의", description: "" },
        ],
        welfares: [
            { name: "개발장비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "점심식사 제공", image: null },
            {
                name: "저녁식사 제공",
                image: null,
            },
            { name: "간식 제공", image: null },
        ],
    },
    {
        name: "(주)큐램",
        registrationNumber: "1148607247",
        devTeam: {
            positions: [
                {
                    name: "머신러닝 엔지니어",
                    total: 10,
                    rookie: 1,
                    junior: 3,
                    senior: 3,
                    leader: 3,
                    skills: ["C++", "C", "Java", "Python"],
                },
                {
                    name: "컴퓨터비전 엔지니어",
                    total: 9,
                    rookie: 3,
                    junior: 2,
                    senior: 3,
                    leader: 1,
                    skills: ["C++", "C", "Java", "Python"],
                },
                {
                    name: "QA 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 3,
                    senior: 1,
                    leader: 0,
                    skills: ["C++", "C", "Java", "Python"],
                },
            ],
            description:
                "큐램 개발팀은 크게 다음과 같이 구성되어 있습니다.\n\n.개발1팀 : 삼성 모든 갤럭시 폰에 라이센싱 되고 있는 이미지 코덱 및 신용카드 신분증 OCR 인식 솔루션 담당\n\n.개발2팀 : SKT, LGU+ 같은 이동통신사들에 5G 서비스를 위한 360 실시간 정합 기술 제공\n\n.개발3팀 : 선행 AI 기술 연구개발\n\n.QA팀 : 큐램 모든 제품들이 세계 최고의 제품이 될 수 있도록 제품 품질 점검 및 경쟁사 제품 분석 담당",
        },
        devStyles: [
            { name: "코드 리뷰", description: "" },
            { name: "주간 개발잡담", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
        ],
        welfares: [
            {
                name: "직원대출제도(주택자금 대출: 최대 2억, 연리 1%)",
                image: null,
            },
            { name: "인센티브", image: null },
            { name: "상여금", image: null },
            { name: "내일채움공제", image: null },
            { name: "장기근속자 포상", image: null },
            { name: "점심식사 제공", image: null },
            {
                name: "저녁식사 제공",
                image: null,
            },
            { name: "간식 제공", image: null },
        ],
    },
    {
        name: "자비스앤빌런즈(삼쩜삼)",
        registrationNumber: "1588600171",
        plan: "standard",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "백엔드 엔지니어",
                    total: 14,
                    rookie: 0,
                    junior: 3,
                    senior: 4,
                    leader: 7,
                },
                {
                    name: "데브옵스 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                },
                {
                    name: "데이터 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 2,
                    senior: 2,
                    leader: 0,
                },
                {
                    name: "모바일 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 1,
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "iOS 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "프로덕트 매니저",
                    total: 10,
                    rookie: 0,
                    junior: 3,
                    senior: 4,
                    leader: 3,
                },
                {
                    name: "UI/UX 디자이너",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                },
            ],
            description:
                "자비스와 삼쩜삼의 성공을 시작으로, 우리는 데이터 기반의 핀테크 기업으로서 세무·회계·금융시장을 리딩합니다. 우리가 꿈꾸는 모든 일은 데이터와 개발에 기반하여 이루어질 것입니다. 이것이 우리가 유능한 개발 인재를 적극적으로 채용하는 이유입니다.",
        },
        devStyles: [
            { name: "주간 개발잡담", description: "" },
            { name: "일별 브리핑", description: "" },
            { name: "그룹 단위 코드리뷰", description: "" },
            { name: "페어 프로그래밍", description: "" },
            { name: "몹프로그래밍", description: "" },
            { name: "보일러플레이트", description: "" },
            { name: "애자일", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
        ],
        welfares: [
            { name: "연 2회 연봉협상 (6월/12월)", image: null },
            {
                name: "상/하반기 인센티브 지급 (1월/7월): 성과에 따라 월 급여의 100%~200% 상당",
                image: null,
            },
            { name: "월별 성과에 따라 Spot성 인센티브 별도 지급", image: null },
            { name: "맥북 등 최신 고급 장비 지원", image: null },
            { name: "성장에 필요한 도서 구입비 및 교육비 지원", image: null },
            { name: "선택적근로시간제 실시", image: null },
            { name: "자율적인 원격 및 재택근무제", image: null },
            {
                name: "점심시간은 넉넉하게 1시간 30분 (실 근무시간 7.5시간!)",
                image: null,
            },
            { name: "각종 경조사 지원: 경조금, 경조휴가", image: null },
            { name: "설/추석 명절 선물 및 생일 선물 지급", image: null },
            {
                name: "결재 필요없는 자유로운 연차 사용 (반차, 반반차 사용 가능)",
                image: null,
            },
        ],
    },
    {
        name: "주식회사 포스타입",
        registrationNumber: "7868600336",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "iOS 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 2,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                },

                {
                    name: "프론트엔드 엔지니어",
                    total: 2,
                    rookie: 2,
                    junior: 0,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "QA 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
            ],
            description:
                "개발자 출신의 CEO가 리드하고 있는 개발팀은 선진적인 기술을 적극적으로 도입하며 구성원들이 지속적으로 성장할 수 있는 개발 문화를 만들어 나가고 있습니다.",
        },
        devStyles: [
            { name: "코드 리뷰", description: "" },
            { name: "애자일", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
        ],
        welfares: [
            { name: "스톡옵션제도", image: null },
            {
                name: "내일채움공제",
                image: null,
            },
            { name: "복지 카드/포인트", image: null },
            { name: "개발장비지원", image: null },
            { name: "점심식사 제공", image: null },
            { name: "간식 제공", image: null },
            { name: "도서 구입비 지원", image: null },
            {
                name: "외부 교육비 지원",
                image: null,
            },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "건강검진 지원", image: null },
            {
                name: "체력 단련비 지원",
                image: null,
            },
        ],
    },
    {
        name: "와이드",
        registrationNumber: "3018140092",
        devTeam: {
            positions: [
                {
                    name: "시스템 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 2,
                    leader: 0,
                },
                {
                    name: "임베디드 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 1,
                    senior: 2,
                    leader: 1,
                },
            ],
            description:
                "개발팀은 맡은 업무에 대해서 능동적으로 개선하고 발전시키는 것을 좋아합니다. 또한 한 가지 기술 분야에 집중해서 깊이 있고 정확한 전문가 역량을 존중합니다. 본인의 기술 및 지식을 공유하고 설명하기 좋아하는 사람을 우대합니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "프로젝트별 역량강화 프로그램 운영", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            { name: "저녁식사 제공", image: null },
            { name: "최신 개발장비 지원", image: null },
            { name: "내일채움공제", image: null },
            { name: "간식 제공", image: null },
            { name: "건강검진 지원", image: null },
            { name: "4대보험", image: null },
            { name: "연차", image: null },
            { name: "교통비 지원", image: null },
            { name: "경조사비 지원", image: null },
            { name: "회식비 지원", image: null },
        ],
    },
    {
        name: "크레파스솔루션",
        registrationNumber: "3718800161",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "백엔드 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 2,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "데이터 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 1,
                },
                {
                    name: "시스템 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 1,
                },
                {
                    name: "보안 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 1,
                },
            ],
            description:
                "개발팀은 맡은 업무에 대해서 능동적으로 개선하고 발전시키는 것을 좋아합니다. 또한 한 가지 기술 분야에 집중해서 깊이 있고 정확한 전문가 역량을 존중합니다.\n본인의 기술 및 지식을 공유하고 설명하기 좋아하는 사람을 우대합니다.",
        },
        devStyles: [
            { name: "엔지니어링 페어", description: "" },
            { name: "Tech세미나", description: "" },
            { name: "애자일 Scrum(스크럼)", description: "" },
        ],
        welfares: [
            { name: "스톡옵션제도", image: null },
            { name: "내일채움공제", image: null },
            { name: "최신 개발장비 지원", image: null },
            { name: "저녁식사 제공", image: null },
            { name: "간식 제공", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "도서 구입비 제공", image: null },
        ],
    },
    {
        name: "주식회사 식스샵",
        registrationNumber: "2208841563",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 8,
                    rookie: 2,
                    junior: 2,
                    senior: 2,
                    leader: 2,
                },
                {
                    name: "백엔드 엔지니어",
                    total: 12,
                    rookie: 2,
                    junior: 4,
                    senior: 4,
                    leader: 2,
                },
            ],
            description:
                "- 애자일 방법론의 Sprint, Scrum을 적용하여 운영하고 있습니다.\n- 본인의 업무에 장시간 동안 집중할 수 있도록 전체 회의는 2주에 한 번씩 하는 스프린트 회의 때 몰아서 합니다.\n- 서로의 설계에 대해 피드백을 하는 시간을 통해 개인과 팀의 성장을 추구합니다.\n- 코드 리뷰를 통한 품질 개선 및 노하우 공유를 중요하게 생각합니다.\n- 동료와 후임자를 위한 히스토리 및 규약 문서들의 작성을 중요하게 생각합니다.\n- 모든 PR은 리뷰를 거치며, 리뷰 시 GitHub의 리뷰 시스템을 이용하여 구체적으로 코멘트들을 기록합니다.\n- 정기적으로 사내 세미나를 열어 최신 기술 트렌드를 공유하며, 구성원들의 성장을 추구합니다.\n- 제품 관리자, 백/프론트엔드 개발자, 제품 디자이너로 구성된 1개의 셀이 1개의 제품을 전담하는 방식으로 업무를 진행합니다. 1개의 셀이 1개 제품의 기획부터 출시까지 적극 참여합니다.\n- 함께 식스샵의 개발 문화를 발전시켜나갈 분을 찾습니다.",
        },
        devStyles: [
            { name: "애자일", description: "" },
            { name: "스프린트", description: "" },
            { name: "피드백", description: "" },
        ],
        welfares: [
            { name: "최신의 최고급 사양 장비 지원", image: null },
            { name: "업무용 유료 소프트웨어 적극 지원", image: null },
            {
                name: "도서 구입비 지원",
                image: null,
            },
            { name: "외부 교육비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "내일채움공제", image: null },
            { name: "건강검진 지원", image: null },
            { name: "신입 기준 20일 이상 휴가 제공", image: null },
            {
                name: "자유로운 휴가 신청(당일 아침, 근무 중 포함)",
                image: null,
            },
            { name: "30분 단위 휴가 사용", image: null },
            { name: "유연근무제", image: null },
            {
                name: "초과 근무 시 시급의 1.5배 수당 제공(원격 초과 근무 포함)",
                image: null,
            },
            { name: "택시비 지원(지정 시간 이후 퇴근 시)", image: null },
            { name: "스톡옵션제도", image: null },
            {
                name: "경조금 지원",
                image: null,
            },
        ],
    },
    {
        name: "플리토",
        registrationNumber: "2158772878",
        plan: "premium",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 1,
                    senior: 2,
                    leader: 1,
                    skills: ["TypeScript", "Angular"],
                },
                {
                    name: "백엔드 엔지니어",
                    total: 13,
                    rookie: 1,
                    junior: 4,
                    senior: 5,
                    leader: 3,
                    skills: ["TypeScript", "AWS", "Kubernetes"],
                },
                {
                    name: "데이터 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 1,
                    skills: ["Python", "R"],
                },
                {
                    name: "iOS 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: ["Swift"],
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: ["Kotlin"],
                },
                {
                    name: "QA 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: [],
                },
                {
                    name: "머신러닝 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 1,
                    skills: ["Python"],
                },
                {
                    name: "프로덕트 매니저",
                    total: 7,
                    rookie: 1,
                    junior: 2,
                    senior: 2,
                    leader: 2,
                    skills: [],
                },
                {
                    name: "UI/UX 디자이너",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: [],
                },
                {
                    name: "브랜드 디자이너",
                    total: 2,
                    rookie: 0,
                    junior: 8,
                    senior: 1,
                    leader: 1,
                    skills: [],
                },
            ],
            description:
                "플리토 개발팀은 협업을 중시하고 끊임없이 더 나은 방식을 찾습니다. 동료를 존중하고 소통하는 개발자, 함께 고민하고 토론하며 성장해갈 동료를 찾습니다!",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "애자일", description: "" },
            { name: "기술 세미나", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "신규 기술 제안", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            { name: "개발장비 지원", image: null },
            { name: "내일채움공제", image: null },
            { name: "건강검진 지원", image: null },
            { name: "스톡옵션제도", image: null },
            { name: "생일휴가", image: null },
            { name: "결혼기념일 반차", image: null },
            { name: "경조사휴가", image: null },
            { name: "경조지원금", image: null },
            { name: "명절상여", image: null },
            { name: "자기개발비", image: null },
            { name: "사내대출", image: null },
        ],
    },
    {
        name: "주식회사 케어닥",
        registrationNumber: "7088100933",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 6,
                    rookie: 1,
                    junior: 2,
                    senior: 2,
                    leader: 1,
                },
                {
                    name: "백엔드 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "데이터 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 1,
                },
                {
                    name: "UI/UX 디자이너",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                },
            ],
            description:
                "케어닥 개발팀은 이렇게 일해요!\n\n협업을 가장 중요시하며 공유를 통한 성장이라는 개발팀의 목표안에서 체계화된 워크플로우를 정립하고 개선해나가려 노력하고 있으며 풀리퀘스트를 통한 코드리뷰 문화를 바탕으로 책임감을 덜고 상호보완을 이루며 일 하고 있습니다. 업무 시에는 할당된 티켓에만 집중하면 되게끔 요구사항에 대한 자료들을 모아 구성하고 있습니다. 또 세미나 컨퍼런스등에 적극 참여하고 있으며 언어에 국한되지 않고 개발팀(CTO포함)전원이 미니워크샵과 같은 내부 개발 조직 문화를 통해 공유를 통한 성장이 활발하게 이루어지고 있습니다. 또한 적절한 도전 과제와 기다려주는 문화를 위해 개발 조직 구성원들의 결을 가꾸어 나가고 있습니다",
        },
        devStyles: [
            { name: "케어닥 표준 워크플로우", description: "" },
            { name: "미니 워크샵", description: "" },
            { name: "풀리퀘스트 기반 코드리뷰", description: "" },
            { name: "지속적 통합 및 배포", description: "" },
            { name: "기술 컨퍼런스", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            {
                name: "도서 구입비 지원",
                image: null,
            },
            { name: "간식 제공", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "내일채움공제", image: null },
        ],
    },
    {
        name: "주식회사 에스앤피랩",
        registrationNumber: "8898701698",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 5,
                    rookie: 0,
                    junior: 4,
                    senior: 0,
                    leader: 1,
                },
                {
                    name: "iOS 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 2,
                    senior: 0,
                    leader: 1,
                },
                {
                    name: "백엔드 엔지니어",
                    total: 7,
                    rookie: 0,
                    junior: 4,
                    senior: 0,
                    leader: 3,
                },
                {
                    name: "블록체인 엔지니어",
                    total: 2,
                    rookie: 1,
                    junior: 0,
                    senior: 0,
                    leader: 1,
                },
                {
                    name: "UI/UX 디자이너",
                    total: 3,
                    rookie: 0,
                    junior: 2,
                    senior: 0,
                    leader: 1,
                },
            ],
            description:
                "흐름을 보고 미래를 설계합니다.\n에스엔피랩은 경험 많은 시니어 프로그래머들로 이루어져 있습니다.\n첨단의 기술과 정보 다루는 기술을 혹독하게 훈련받으며 일해왔습니다.\n하루가 다르게 변화하는 IT 기술의 여러 분야를 다루며,\n혁신기술이 변화하는 현장을 직접 함께 해왔습니다.\n그런 만큼 큰 흐름을 예측하고 이에 따라 비젼을 가지고 미래를 설계할 수 있습니다.\n\n우리는 서로가 멘토이며 멘티입니다.\n우리는 서로 연구하고 배우며 함께 끊임없이 일깨우며 성장하는 기업입니다.\n에스엔피랩의 지붕 아래 모인 팀원들의 공통적인 성향대로,\n서로 존중하고 경청하며 의견을 조율하는 방식이 자연스럽게 자리잡았습니다.\n기꺼이 지식과 정보를 공유하며 팀 구성원들을 배려하며 일하는 기업입니다.\n가장 효율적이고 산업성장을 이루는 기업은\n팀원이 아이디어를 창출하고 기술을 혁신할 수 있는 환경을 제공하는 기업입니다.\n에스엔피랩은 새로운 기업문화를 통해\n모두가 즐겁게 일할 수 있는 기업을 만들 것입니다.\n곧 다른 기업들은 기업경영과 사원경영에 대한 새로운 모델로\n에스엔피랩을 주목하고 따르게 될 것입니다.",
        },
        devStyles: [{ name: "수평적 커뮤니케이션", description: "" }],
        welfares: [
            { name: "점심식사 제공", image: null },
            {
                name: "도서 구입비 지원",
                image: null,
            },
            { name: "간식 제공", image: null },
            { name: "스톡옵션제도", image: null },
            { name: "건강검진 지원", image: null },
            { name: "내일채움공제", image: null },
        ],
    },
    {
        name: "젠틀에너지(주)",
        registrationNumber: "4648101482",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 2,
                    rookie: 1,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "백엔드 엔지니어",
                    total: 3,
                    rookie: 2,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },

                {
                    name: "데이터 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "데이터 분석가",
                    total: 2,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 1,
                },
                {
                    name: "임베디드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
                {
                    name: "UI/UX 디자이너",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                },
            ],
            description:
                "젠틀에너지 개발팀은 자유로운 수평 분위기 속에 합리성을 추구합니다. 우리회사에서는 업무를 담당하는 실무자의 의견이 최우선이 되며, 자기 주도적으로 개발합니다.",
        },
        devStyles: [
            { name: "애자일", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "자기주도 개발", description: "" },
            { name: "코드리뷰", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            { name: "저녁식사 제공", image: null },
            { name: "간식 제공", image: null },
            {
                name: "도서 구입비 지원",
                image: null,
            },
            { name: "개발장비지원", image: null },
            { name: "스톡옵션제도", image: null },
            { name: "출근시간 유연제", image: null },
        ],
    },
    {
        name: "주식회사 룰루랩",
        registrationNumber: "4358800655",
        devTeam: {
            positions: [
                {
                    name: "데이터 엔지니어",
                    total: 6,
                    rookie: 3,
                    junior: 1,
                    senior: 0,
                    leader: 2,
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 0,
                    senior: 0,
                    leader: 3,
                },
                {
                    name: "UI/UX 디자이너",
                    total: 2,
                    rookie: 1,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                },
                {
                    name: "그래픽 디자이너",
                    total: 1,
                    rookie: 1,
                    junior: 0,
                    senior: 0,
                    leader: 0,
                },
            ],
            description:
                "룰루랩의 유상욱 최고기술책임자는 KAIST에서 전산학 박사 학위를 받은 후 삼성전자 헬스케어 사업부에서 의료영상 분석 알고리즘을 개발했고, 이후에 삼성전자 C-Lab에서 루미니 프로젝트 개발을 진행하였습니다. 이미 머신 러닝 기반의 의료 영상 분석 연구를 진행하며 데이터 확보의 어려움과 한계를 느꼈고 동시에 피부 데이터 수집의 용이성을 인지하고 있던 그는 2017년 C-Lab 스핀오프 기업을 공동 창업하기로 결정하고 현재 루미니의 인공지능 기술을 지속적으로 고도화하고 있습니다. 유상욱 최고기술책임자는 축적된 피부 데이터와 인공지능 기술을 활용해 미래에는 인간이 간과할 수 있는 다양한 오류들을 넘어설 수 있는 기술 개발을 목표로 하고 있습니다.\n\n현재 룰루랩의 개발팀은 21년 룰루랩 사업 확장과 더불어 CTO 산하의 3개 팀으로 운영되고 있습니다.\n\nAI개발팀은?\n룰루랩의 루미니 피부분석 알고리즘 개발 및 다양한 영상처리 기술을 활용한 룰루랩 솔루션의 코어 알고리즘 개발을 담당하고 있습니다.\n영상처리, 패턴인식, 머신러닝 전문가들로 구성되어 있으며, 당사의 사업확장 및 다양화에 따라 지속적으로 전문가들을 위촉하고 있습니다.\n\n앱플랫폼개발팀은?\n룰루랩에서 연구개발 중인 피부분석 솔루션을 기반으로 B2B, B2C 등 다양한 형태의 서비스를 개발하고, 고객에게 최적의 UI/UX 환경에서 룰루랩만의 특화된 서비스를 이용할 수 있도록 개발하고 있습니다.\nAndroid, iOS, 서버, UI/UX 디자이너 등 각 서비스 분야의 전문가들로 구성되어 최상의 룰루랩 앱 서비스를 개발하고 있습니다.\n\n디바이스개발팀은?\n룰루랩의 자체적인 Hardware 기술 기반으로 피부 분석 디바이스 개발을 집중적으로 수행하는 조직입니다. 광학 및 센서, 무선 통신 기술 등을 활용하여 소형 포터블기기, 스마트 미러, 키오스크 등 다양한 형태로 룰루랩의 피부 측정 제품들을 실현해내고 있습니다.\n현재 회로, 기구, Firmware 등 각 세부 분야 전문가들로 구성되어 있으며, 관련 분야의 전문가들을 계속해서 모집하고 있습니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "주간 미팅", description: "" },
            { name: "팀 미팅", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            { name: "저녁식사 제공", image: null },
            { name: "간식 제공", image: null },
            {
                name: "도서 구입비 지원",
                image: null,
            },
            { name: "개발장비지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "내일채움공제", image: null },
            { name: "생일 선물 및 반차 제공", image: null },
        ],
    },
    {
        name: "(주)로랩스",
        registrationNumber: "2948701037",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 0,
                    senior: 2,
                    leader: 0,
                    skills: [
                        "JavaScript",
                        "TypeScript",
                        "Node.js",
                        "NestJS",
                        "TypeORM",
                        "Puppeteer",
                        "PostgreSQL",
                        "NoSQL",
                        "Socket.IO",
                        "CI/CD",
                        "AWS",
                        "Tensorflow",
                    ],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: [
                        "HTML",
                        "CSS",
                        "JavaScript",
                        "TypeScript",
                        "React",
                        "Next.js",
                        "Mobx",
                        "Ant design",
                        "Electron",
                        "React Native",
                    ],
                },
                {
                    name: "UI/UX 디자이너",
                    total: 2,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["Photoshop", "Figma", "Zeplin", "Illustrator"],
                },
            ],
            description:
                "안녕하세요. 클라우드 기반 구매관리 솔루션, 에어서플라이를 만드는 (주)로랩스 개발팀입니다.\n저희는 사용자의 가치를 최우선으로 생각하고 빠르고 유동적인 개발 문화를 갖고 있습니다.\n- Github를 활용해 협업합니다.\n- Restful API를 통해 프론트와 백엔드를 연결합니다.\n- FIgma를 통해 기획/디자인과 소통합니다.\n- DevOps 개발을 지향하며 CI/CD 자동화 환경을 만들어 나갑니다.\n- 개발자와 엔드유저와의 소통을 통해 서비스를 운영해 나갑니다.\n- 컴포넌트 디자인의 React 개발 방향을 추구하며 디자인팀과 긴밀히 협업하고 있습니다.\n\n저희와 함께 700만 중소기업의 구매 시장을 혁신할 도전적인 분들을 찾고 있습니다.",
        },
        devStyles: [
            { name: "Gitflow", description: "" },
            { name: "코드리뷰", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "CI/CD", description: "" },
            { name: "애자일", description: "" },
        ],
        welfares: [
            { name: "간식 제공", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "개발장비지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "내일채움공제", image: null },
            { name: "스톡옵션제도", image: null },
            { name: "우리사주제도", image: null },
        ],
    },
    {
        name: "주식회사 밴플",
        registrationNumber: "4128801781",
        devTeam: {
            positions: [
                {
                    name: "풀스택 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                    skills: [
                        "Vue.js",
                        "TypeScript",
                        "Sequelize.js",
                        "Express.js",
                    ],
                },
                {
                    name: "백엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: ["Node.js", "MariaDB", "Sequelize"],
                },
                {
                    name: "UI/UX 디자이너",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: ["Figma"],
                },
                {
                    name: "프로덕트 매니저",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: ["Notion"],
                },
            ],
            description:
                "- 전사가 2주 단위 스프린트로 업무를 진행하고 있고, Jira를 프로덕트 관리 기본 툴로 쓰고 있습니다.\n- 격주 월요일마다 스프린트 플래닝을 진행하고, 격주 목요일마다 스프린트 리뷰와 함께 Deploy, 금요일에는 QA를 하는 스케쥴입니다.\n- 100% 리모트워크 기업으로, 월~금요일 동안 주 40시간을 재택/원격 근무합니다.\n- 전용 구글 미트 링크가 있어서, 필요할 때는 언제든지 접속해 다른 엔지니어와 상의하며 업무를 진행할 수 있습니다.\n- 일 단위로 출퇴근 시간을 자율 설정할 수 있습니다.\n- 시간 단위로 연차를 쓸 수 있습니다.\n- 회의/미팅 등 필요시 사무실(서울 마포구 홍대입구역) 출근이 가능합니다.\n- 업무에 필요 시, 역량을 성장시킬 수 있는 교육 콘텐츠를 지원합니다.\n            ",
        },
        devStyles: [
            { name: "애자일", description: "" },
            { name: "2주 단위 스프린트", description: "" },
            { name: "코드 리뷰", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "실시간 커뮤니케이션", description: "" },
            { name: "페어 프로그래밍", description: "" },
            { name: "데일리 스탠드업 미팅", description: "" },
            { name: "Jira", description: "" },
            { name: "CI/CD Deploy", description: "" },
            { name: "완전 원격 근무", description: "" },
        ],
        welfares: [
            { name: "외부 교육비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "개발장비지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "내일채움공제", image: null },
            { name: "명절 선물 제공", image: null },
            { name: "시단위 연차", image: null },
            { name: "재량근로시간제", image: null },
        ],
    },
    {
        name: "(주)버드뷰",
        registrationNumber: "2328100912",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 16,
                    rookie: 0,
                    junior: 8,
                    senior: 6,
                    leader: 2,
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 10,
                    rookie: 1,
                    junior: 4,
                    senior: 4,
                    leader: 1,
                },
                {
                    name: "iOS 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 1,
                    senior: 2,
                    leader: 1,
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 5,
                    rookie: 1,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "데이터 엔지니어",
                    total: 5,
                    rookie: 0,
                    junior: 2,
                    senior: 2,
                    leader: 1,
                },
                {
                    name: "데이터 분석가",
                    total: 4,
                    rookie: 0,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "UI/UX 디자이너",
                    total: 6,
                    rookie: 1,
                    junior: 1,
                    senior: 2,
                    leader: 2,
                },
                {
                    name: "프로덕트 매니저",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "브랜드 디자이너",
                    total: 8,
                    rookie: 2,
                    junior: 2,
                    senior: 2,
                    leader: 2,
                },
                {
                    name: "데브옵스 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "보안 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 1,
                },
                {
                    name: "머신러닝 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 1,
                    senior: 2,
                    leader: 0,
                },
            ],
            description:
                "저희 화해 개발팀은\n\n•  나이, 경력, 직급이 아닌 서로에 대한 신뢰와 존중을 기반으로 자유롭게 의견을 나눕니다.\n\n•  문제를 해결해 나가기 위해 새로운 기술 도입에 열려 있습니다. 새로운 기술을 함께 스터디하고, 적극적으로 공유합니다.\n\n•  엔지니어링 백로그를 통해 기술적 문제를 공유하고, 이에 대한 솔루션 도출을 공동으로 논의합니다.\n\n•  개인과 공동의 지속적인 성장을 위해 코드 리뷰, 회고 등을 적극적으로 진행하고 있습니다.\n\n•  매주 금요일 테크 밋업을 비롯해 개발팀이 함께 성장할 수 있는 특별한 문화 행사를 진행합니다.",
        },
        devStyles: [
            {
                name: "코드리뷰",
                description: "데일리 1시간 (인원 별로 시간이 다름)",
            },
            { name: "플랫폼별 회고", description: "주1회 진행" },
            { name: "엔지니어링 백로그", description: "데일리 15분씩" },
            { name: "데일리 스탠드업", description: "데일리 15분씩" },
            {
                name: "1on1",
                description: "리더와 구성원의 1:1 티타임",
            },
            {
                name: "Engineering Ladders",
                description:
                    "소프트웨어 엔지니어의 커리어 성장을 위한 프레임워크",
            },
            { name: "기술 개선 논의", description: "" },
            { name: "스터디", description: "" },
            { name: "기술블로그 작성 모임", description: "" },
            { name: "설계 가이드", description: "" },
            { name: "컨벤션 문서", description: "" },
            { name: "테크스펙 작성", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            { name: "저녁식사 제공", image: null },
            { name: "간식 제공", image: null },
            { name: "개발장비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "건강검진 지원", image: null },
            { name: "체력 단련비 지원", image: null },
            {
                name: "화장품 구입비: 월 최대 5만원(연간 600,000원)",
                image: null,
            },
            {
                name: "명절 선물: 설/추석 200,000원 백화점 상품권(연간 400,000원)",
                image: null,
            },
            {
                name: "생일/입사일 선물: 50,000원 백화점 상품권(연간 100,000원)",
                image: null,
            },
            { name: "자율휴가제(휴가 일수 무제한) 사용", image: null },
            {
                name: "아빠새 휴가(배우자 출산 휴가): 배우자 출산 시 4주의 유급 휴가",
                image: null,
            },
        ],
    },
    {
        name: "(주)아이알엠",
        registrationNumber: "1448108465",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: ["Java", "JSP", "JavaScript", "React", "jQuery"],
                },
                {
                    name: "백엔드 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 0,
                    senior: 1,
                    leader: 1,
                    skills: [
                        "Java",
                        "Spring",
                        "C++",
                        "Python",
                        "Pytorch",
                        "PostgreSQL",
                        "AWS",
                    ],
                },
                {
                    name: "영상처리 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 0,
                    senior: 0,
                    leader: 2,
                    skills: ["JavaScript", "Java", "C++"],
                },
            ],
            description:
                "현재 개발팀은 프론트, 백엔드, 뷰어팀의 3개로 구성되어 있으며, 개발 인력을 15명으로 확장하려 합니다.\n\n 1. 프론트팀에서는 의료데이터 및 의료영상의 사용자들(주로 의사들)을 위한 UI/UX를 개발하며 JavaScript, React, Spring 등을 주로 사용하고 있습니다.\n 2. 백엔드팀은 초대용량 의료데이터 처리 플랫폼을 개발하고 있으며 PostgreSQL, Java, C++, JavaScript, Python 등을 주로 사용하고 있습니다.\n 3. 뷰어팀에서는 DICOM 의료영상, Pathology 영상, 2D/3D/4D 영상 등 다양한 의료영상을 디스플레이하고 처리하는 일을 하며 대부분의 개발환경은 JavaScript, Java, C++ 등으로 구성되어 있습니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "주간회의", description: "" },
            { name: "월간회의", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            { name: "간식 제공", image: null },
            { name: "개발장비 지원", image: null },
            { name: "내일채움공제", image: null },
            { name: "통신비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "도서 구입 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "스톡옵션제도", image: null },
        ],
    },
    {
        name: "소다크루",
        registrationNumber: "6218800275",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 5,
                    rookie: 0,
                    junior: 2,
                    senior: 1,
                    leader: 2,
                    skills: [
                        "Java",
                        "Spring",
                        "Junit",
                        "AssertJ",
                        "MySQL",
                        "Flyway",
                        "AWS",
                        "Jenkins",
                        "Nginx",
                        "Elasticsearch",
                        "Logstash",
                        "Kibana",
                        "git",
                        "Intellij",
                        "Postman",
                        "Slack",
                        "Jira",
                    ],
                    link: {
                        label: "· [노션] 백엔드팀이 일하는 방법",
                        url: "https://sodagift.notion.site/af5148b6fcfd43edacd46103d2354a29",
                    },
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 5,
                    rookie: 1,
                    junior: 1,
                    senior: 3,
                    leader: 0,
                    skills: [
                        "Vue.js",
                        "Nuxt.js",
                        "React",
                        "Next.js",
                        "MobX",
                        "React Native",
                        "TypeScript",
                        "AWS",
                        "Slack",
                        "Jira",
                    ],
                    link: {
                        label: "· [노션] 프론트엔드팀이 일하는 방법",
                        url: "https://sodagift.notion.site/sodagift/486498be62be4a55b4c58fdd95a00de7",
                    },
                },
            ],
            description:
                '소다크루의 개발팀은 "함께 자라기"를 추구합니다. 적극적인 코드 리뷰와 빠른 피드백을 위한 지속적인 코드 병합 전략을 추구하고 있습니다. 또한 개발 과정에서 필요한 지식 혹은 문제에 대한 해결책을 빠르고 수평적으로 공유합니다.\n\n현재 소다크루의 글로벌 서비스 소다기프트는 서비스 트래픽과 거래액이 증가하면서 서비스를 안정적으로 확장해야 하는 미션이 있습니다. 함께 생각하고, 성장하고, 성취하는 새로운 크루가 되어보세요.',
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "페어프로그래밍", description: "" },
            { name: "주간 리팩토링 미팅", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "테스트 자동화", description: "" },
            { name: "도메인 주도 설계", description: "" },
            { name: "CI/CD", description: "" },
        ],
        welfares: [
            { name: "선택적 원격 근무", image: null },
            { name: "유연근무제", image: null },
            { name: "무제한 휴가", image: null },
            { name: "개발장비 지원", image: null },
            { name: "교육비 지원", image: null },
            { name: "도서비 지원", image: null },
            { name: "간식 제공", image: null },
            { name: "청년내일채움공제", image: null },
            { name: "결혼/출산 축하금", image: null },
            { name: "명절 선물", image: null },
        ],
    },
    {
        name: "더핑크퐁컴퍼니",
        registrationNumber: "2148859980",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: [
                        "Python",
                        "Django",
                        "Docker",
                        "MySQL",
                        "PostgreSQL",
                        "MongoDB",
                        "Redis",
                        "Amazon RDS",
                    ],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: ["React"],
                },
                {
                    name: "iOS 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: ["Swift", "Objective-C"],
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: ["Java", "Kotlin"],
                },
                {
                    name: "데이터 엔지니어",
                    total: 4,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 1,
                    skills: [
                        "Python",
                        "MySQL",
                        "PostgreSQL",
                        "MongoDB",
                        "Redis",
                        "Amazon RDS",
                    ],
                },
            ],
            description:
                "더핑크퐁컴퍼니는 스마트폰의 등장부터 발빠르게 대응하며 앱을 출시해 성공을 이끌어 온, 기술이 주도하는 기업입니다. 키즈 콘텐츠 및 서비스 시장 속에서 독보적으로 선구적인 기술을 이용해 최신 플랫폼에 발맞춰 왔습니다.\n\n합리적이고 효율적인 개발 문화를 지향하며, Github Enterprise&Actions, Slack, Notion, Google Drive 등의 업무툴을 사용합니다.사내 스터디, 외부 세미나를 지원하고 출퇴근시간 자율 / 원격, 재택 자율 등 업무 효율 향상을 위한 자율을 부여하고 있습니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "데일리 스크럼", description: "" },
            { name: "주간 업무 공유", description: "" },
            { name: "수평적 의사소통", description: "" },
            { name: "자율적 개발도구/라이브러리 선택", description: "" },
        ],
        welfares: [
            { name: "간식 제공", image: null },
            { name: "유연근무제", image: null },
            { name: "개발장비 지원", image: null },
            { name: "도서비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "전세자금 대출", image: null },
            { name: "우리사주제도", image: null },
            { name: "스톡옵션제도", image: null },
        ],
    },
    {
        name: "두들린",
        registrationNumber: "5138601891",
        serviceLink: "https://www.greetinghr.com",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 4,
                    senior: 0,
                    leader: 0,
                    skills: ["Java", "Kotlin", "NestJS", "Spring"],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 3,
                    senior: 0,
                    leader: 0,
                    skills: ["TypeScript", "React"],
                },
                {
                    name: "데이터 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: ["Python"],
                },
                {
                    name: "프로덕트 매니저",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["Notion", "Figma"],
                },
                {
                    name: "UI/UX 디자이너",
                    total: 3,
                    rookie: 0,
                    junior: 3,
                    senior: 0,
                    leader: 0,
                    skills: ["Figma", "Adobe CC"],
                },
            ],
            description:
                "두들린은 꿈이 있는 분을 선호하고, 그 꿈을 두들린에서 이룰 수 있도록 도와드리고 있어요! 두들린 개발팀은 제품에 대해 끊임없이 고민하고, 생각을 나누고 있어요! 그리고 더 좋은 기술, 서비스를 끊임없이 공부하고 공유하며 서로 성장하고 있어요!\n\n✨ 이런 분들이 두들린 ‘개발팀'에 딱이에요!\n- 꿈을 꾸는 엔지니어\n- 제품(개발)에 대해 이야기하는 것을 즐기는 분\n- 빠르고 압축적으로 성장하고 싶은 분",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "주간 테크 공유 소모임", description: "" },
            { name: "CI/CD", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            { name: "간식 제공", image: null },
            { name: "개발장비 지원", image: null },
            { name: "도서비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "무제한 휴가 지원", image: null },
        ],
    },
    {
        name: "오픈서베이",
        registrationNumber: "1068677081",
        serviceLink: "https://www.opensurvey.co.kr",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 8,
                    rookie: 0,
                    junior: 4,
                    senior: 3,
                    leader: 2,
                    skills: [
                        "Java",
                        "Spring / Spring Boot",
                        "Kotlin",
                        "MySQL",
                        "JPA",
                        "Redis",
                    ],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 5,
                    rookie: 0,
                    junior: 2,
                    senior: 2,
                    leader: 1,
                    skills: ["React", "TypeScript", "Figma", "Jest"],
                },
                {
                    name: "iOS 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 1,
                    skills: [
                        "Swift",
                        "Cocoa",
                        "Firebase",
                        "Xcode",
                        "SPM",
                        "Fastlane",
                    ],
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: [
                        "Java",
                        "Firebase",
                        "LiveData",
                        "RxJava",
                        "RxAndroid",
                        "Retrofit",
                        "OkHttp",
                        "Dagger2",
                        "Glide",
                    ],
                },
                {
                    name: "데브옵스 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 1,
                    skills: ["Kubernetes", "AWS", "Jenkins", "Linux"],
                },
                {
                    name: "QA 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 2,
                    skills: ["Jira", "Confluence"],
                },
            ],
            description:
                "오픈서베이 개발팀은 프로덕트에 따라 Tribe 를 구분하고, 각 Tribe에서는 목표 기반의 Squad 형식의 조직을 운영합니다. 더 좋은 프로덕트를 만들기 위해 지속 가능한 개발을 목표로 공동 성장, 협업에 높은 가치를 두고 있어요.\n검증을 거친 새로운 기술 도입에도 적극적이며, 자율 재택근무, 선택적 근로시간제 등의 시스템을 바탕으로 유연하고 자율적으로 일하는 조직입니다.\n\n* 백엔드: 데이터를 효율적으로 처리하고 복잡한 프로세스를 단순화하도록 문제를 정의하고 해결합니다. 고성능 스몰 데이터 처리 프로세스, 실시간 데이터 수집 등 데이터 처리 관련 개발업무를 담당합니다.\n* 프론트엔드: Data visualization, 성능 튜닝 등의 문제를 정의하고 해결합니다. 다양한 형식의 사용자 경험 데이터를 수집할 수 있도록 UX를 함께 고민하고 이를 구현합니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "주간 리뷰", description: "" },
            { name: "스크럼(스프린트)", description: "" },
            { name: "스쿼드(애자일)", description: "" },
        ],
        welfares: [
            { name: "간식 제공", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "개발장비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "복지 카드/포인트", image: null },
            { name: "내일채움공제", image: null },
            { name: "교통비 지원", image: null },
            { name: "건강검진 지원", image: null },
            { name: "체력 단련비 지원", image: null },
            { name: "우리사주제도", image: null },
            { name: "스톡옵션제도", image: null },
            { name: "자율 재택근무", image: null },
            { name: "선택적 근로시간제", image: null },
        ],
    },
    {
        name: "아이엠에스모빌리티",
        registrationNumber: "2808600274",
        serviceLink: "https://imsmobility.co.kr/",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 5,
                    rookie: 1,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                    skills: [
                        "Python",
                        "Go",
                        "MySQL",
                        "AWS",
                        "Flask",
                        "SQLAlchemy",
                        "Kubernetes",
                        "Redis",
                    ],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 6,
                    rookie: 0,
                    junior: 4,
                    senior: 2,
                    leader: 0,
                    skills: [
                        "JavaScript",
                        "React",
                        "React Native",
                        "TypeScript",
                        "Vue.js",
                    ],
                },
                {
                    name: "iOS 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: ["Swift"],
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                    skills: ["Java", "Kotlin"],
                },
                {
                    name: "데브옵스 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                    skills: ["Kubernetes", "AWS"],
                },
                {
                    name: "UI/UX 디자이너",
                    total: 2,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["XD", "Zeplin"],
                },
            ],
            description:
                "아이엠에스 모빌리티 개발팀은 동료의 일하는 방식을 존중합니다. 끊임없이 더 나은 방법을 시작 이를 공유합니다.",
            link: {
                label: "· [블로그] IMS.일상",
                url: "https://blog.naver.com/PostList.naver?blogId=rencars&categoryNo=21&from=postList",
            },
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "애자일", description: "" },
            { name: "페어프로그래밍", description: "" },
        ],
        welfares: [
            { name: "간식 제공", image: null },
            { name: "개발장비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "교육사이트 지원", image: null },
            { name: "AWS계정 지원", image: null },
        ],
    },
    {
        name: "알티엠",
        registrationNumber: "2138641955",
        serviceLink: "https://rtm.ai/",
        devTeam: {
            positions: [
                {
                    name: "머신러닝 엔지니어",
                    total: 14,
                    rookie: 4,
                    junior: 6,
                    senior: 3,
                    leader: 1,
                    skills: ["Linux", "Python", "PyTorch"],
                },
                {
                    name: "풀스택 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                    skills: [
                        "MongoDB",
                        "TypeScript",
                        "JavaScript",
                        "React",
                        "Node.js",
                        "FastAPI",
                    ],
                },
                {
                    name: "백엔드 엔지니어",
                    total: 2,
                    rookie: 1,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: [
                        "MongoDB",
                        "TypeScript",
                        "JavaScript",
                        "Node.js",
                        "FastAPI",
                    ],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: ["TypeScript", "JavaScript", "ReactJS"],
                },
            ],
            description:
                "RTM의 개발팀은 다양한 알고리즘 처리 및 인공지능 모델 딜리버리등을 처리할 수 있는 AI 공정 진단의 솔루션을 개발합니다. 이런 목표를 달성하기 위해 팀은 정확한 원칙을 세우고 이에 따라 개발하며 유연한 사고 방식으로 문제 해결에 접근하고 있습니다.\n저희 개발팀의 목표는 좋은 코드, 깨끗한 아키텍처, 낮은 개발 비용과 서로에게 좋은 동료가 되기를 지향합니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "주간리뷰", description: "" },
            { name: "애자일", description: "" },
            { name: "개발스터디", description: "" },
        ],
        welfares: [
            { name: "점심식사 제공", image: null },
            { name: "개발장비 지원", image: null },
            { name: "간식 제공", image: null },
            { name: "경조사비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "복지 카드/포인트", image: null },
            { name: "내일채움공제", image: null },
            { name: "자유로운 연차 사용", image: null },
            { name: "자율출퇴근제(코어타임제)", image: null },
            { name: "직무발명보상제도 운영", image: null },
            { name: "사업계획 달성 시 모든 구성원 스톡옵션 지급", image: null },
        ],
    },
    {
        name: "섹타나인",
        registrationNumber: "5708501897",
        serviceLink: "https://www.secta9ine.co.kr/",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 29,
                    rookie: 5,
                    junior: 12,
                    senior: 8,
                    leader: 4,
                    skills: ["Linux", "Java", "JavaScript", "Oracle"],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 23,
                    rookie: 3,
                    junior: 6,
                    senior: 11,
                    leader: 4,
                    skills: ["Java", "Spring"],
                },
            ],
            description:
                "더 나은 일상을 디자인하는 SPC그룹의 IT 서비스 및 마케팅 총괄 회사입니다.\n기술과 사람의 상상력이 서로 어울려, 모두에게 닿는 일상의 변화를 만들어 나갑니다. 모든 비지니스 영역에 IT기술과 마케팅의 감성으로 혁신적이고 트렌디한 변화를 선도하며 나아가 모두의 일을 더욱 스마트 하게 만들어갑니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "주간리뷰", description: "" },
            { name: "애자일", description: "" },
            { name: "개발스터디", description: "" },
        ],
        welfares: [
            { name: "조식 지원", image: null },
            { name: "SPC브랜드 할인 지원", image: null },
            { name: "학자금 지원", image: null },
            { name: "건강검진 지원", image: null },
            { name: "상해보험 지원", image: null },
            { name: "경조사 지원", image: null },
            { name: "장기근속 및 우수사원 포상", image: null },
            { name: "웰컴키트 제공", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "자기계발 지원", image: null },
            { name: "유연근무제 시행", image: null },
            { name: "멘토링 제도 운영", image: null },
            { name: "정기 리프레시 휴가지원", image: null },
            { name: "월 10만원 복지포인트 지원", image: null },
            { name: "월 1회 단축 근무", image: null },
            { name: "동호회 지원", image: null },
            { name: "기념일 지원", image: null },
            { name: "명절교통비 지원", image: null },
        ],
    },
    {
        name: "아이지에이웍스",
        registrationNumber: "2208741741",
        serviceLink: "https://www.dfinery.io/",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 10,
                    rookie: 2,
                    junior: 3,
                    senior: 3,
                    leader: 2,
                    skills: [
                        ".NET Core",
                        "Python",
                        "Linux",
                        "Docker",
                        "AWS",
                        "Apache Spark",
                        "Jenkins",
                    ],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 10,
                    rookie: 2,
                    junior: 3,
                    senior: 3,
                    leader: 2,
                    skills: [
                        "Vue.js",
                        "Vuex",
                        "TypeScript",
                        "Sass",
                        "Git",
                        "Figma",
                        "FigJam",
                    ],
                },
                {
                    name: "데이터 엔지니어",
                    total: 5,
                    rookie: 1,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                    skills: [
                        "SQL/Stored Procedure",
                        "MySQL",
                        "Python",
                        "C#",
                        "AWS",
                    ],
                },
                {
                    name: "iOS 엔지니어",
                    total: 5,
                    rookie: 1,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                    skills: ["Swift", "Objective-C", "Xcode"],
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 5,
                    rookie: 1,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                    skills: ["Java", "Android Studio"],
                },
                {
                    name: "머신러닝 엔지니어",
                    total: 5,
                    rookie: 1,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                    skills: ["Python", "Tensorflow", "PyTorch", "AWS"],
                },
            ],
            description:
                '[디파이너리 소개]\n저희가 해결하고 싶은 과제는 "데이터로부터 고객을 이해하고 개인화 마케팅을 통해 고객 생애 가치를 극도로 끌어올려 매출을 증가시키는 플랫폼을 제작하고, 이를 직관적이고 쉬운 방법으로 기업에 제공하는 것" 입니다. 업계에서는 이를 Customer Data Platform(이하 CDP)으로 부르고 있습니다.\n디파이너리팀은 B2B SaaS를 기업들에게 제공하는 회사입니다. 2014년 세상에 처음 선보인 이후 약 10,000여개의 고객에게 CDP를 제공하며 대한민국을 대표하는 1등 CDP가 되었습니다.\n디파이너리는 1년 약 1조개의 이벤트를 처리하고 있습니다. 압도적으로 많은 데이터를 처리할 수 있는 아키텍처를 설계하여, 개발/운영 하고 있습니다. 최근에는 국내외 여러 기업이 디지털 트랜스포메이션을 하려는 움직임이 많아 아이지에이웍스를 더 필요로 하게 되었습니다.\n\n[팀 소개]\n디파이너리의 “웹 서비스” 즉, 우리 플랫폼에서 고객이 경험할 수 있는 모든 곳을 만들고있습니다.\n- 웹 서비스를 기획&디자인을 총괄하는 조직과\n- 웹 서비스를 개발을 총괄하는 조직이 함께 디파이너리 웹 서비스를 만들고 있습니다.\n기획 & 개발 파트가 원팀으로 함께 제품을 만들어 가고있습니다.',
            // link: {
            //     label: "아이지에이웍스 공식 블로그",
            //     url: "https://www.igaworksblog.com/",}
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "주간 개발 잡담", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
        ],
        welfares: [
            { name: "자율 시차출퇴근제", image: null },
            { name: "월 1회 해피데이(지연출근 혹은 조기퇴근)", image: null },
            { name: "월 2회 재택근무", image: null },

            {
                name: "전 직군 성과에 따른 인센티브 및 포상금 지급",
                image: null,
            },
            { name: "자기 계발비 지원(도서 무제한 지원)", image: null },
            { name: "커피, 음료, 아이스크림 등 무제한 제공", image: null },
            { name: "최고급 업무 장비 지원", image: null },
            { name: "국내외 워크샵 및 팀 활동비 지원", image: null },
            { name: "사내 동호회 운영 및 활동비 지원", image: null },
            { name: "생일 기념 휴가 및 축하 상품권 제공", image: null },
            { name: "명절 상품권 지급", image: null },
            { name: "최고급 정밀건강검진", image: null },
            { name: "장기근속 포상 휴가 및 지원금", image: null },
            { name: "임직원 경조사비 지원", image: null },
            { name: "청년내일채움공제 지원", image: null },
            { name: "웰컴 키트", image: null },
        ],
    },
    {
        name: "글로브포인트",
        registrationNumber: "1078772034",
        serviceLink: "https://www.vrware.us",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 2,
                    rookie: 1,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: ["JavaScript", "React"],
                },
                {
                    name: "백엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                    skills: ["Node.js", "AWS"],
                },
                {
                    name: "풀스택 엔지니어",
                    total: 0,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 0,
                    skills: ["JavaScript", "React", "Node.js", "AWS"],
                },
                {
                    name: "AR/VR 엔지니어",
                    total: 6,
                    rookie: 0,
                    junior: 3,
                    senior: 3,
                    leader: 0,
                    skills: ["C#", "Unity"],
                },
            ],
            description:
                "자기개발을 열심히 하며, 책임감 있는 사람을 찾고 있습니다.",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "형상관리 툴을 사용한 프로젝트 관리", description: "" },
            {
                name: "개별 프로젝트 진행 및 팀 단위 프로젝트 진행",
                description: "",
            },
        ],
        welfares: [
            { name: "개발장비 지원", image: null },
            { name: "간식 제공", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "컨퍼런스 참가비 지원", image: null },
            { name: "체력단련비 지원", image: null },
            { name: "유류비 지원", image: null },
            { name: "각종 경조금 지원", image: null },
            { name: "경조휴가", image: null },
            { name: "저녁식사 제공", image: null },
            { name: "내일채움공제", image: null },
            { name: "인센티브제도", image: null },
        ],
    },
    {
        name: "더블미",
        registrationNumber: "7338800035",
        serviceLink: "https://www.doubleme.me/",
        devTeam: {
            positions: [
                {
                    name: "안드로이드 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["Android Studio", "Java", "Kotlin", "Unity"],
                },
                {
                    name: "iOS 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["Swift", "Unity"],
                },
                {
                    name: "백엔드 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["C#", "C++", "C"],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["Unity", "Unreal"],
                },
                {
                    name: "풀스택 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: [
                        "TypeScript",
                        "NestJS",
                        "TypeORM",
                        "WebGL",
                        "WebXR",
                    ],
                },
                {
                    name: "AR/VR 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["Unity"],
                },
                {
                    name: "컴퓨터비전 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["C", "C++", "SLAM", "CUDA"],
                },
                {
                    name: "데브옵스 엔지니어",
                    total: 3,
                    rookie: 1,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["Jenkins", "Docker", "Kubernetes", "AWS"],
                },
            ],
            description:
                "더블미는 2016년 런던, 2017년 서울에 국내 최초, 세계 3번째 볼류메트릭 비디오 캡쳐 스튜디오를 운영하여 전세계 300개 이상의 혼합현실 (Mixed Reality) 프로젝트 진행했습니다. 창업 멤버는 모두 3D 그래픽스 및 컴퓨터비전 전문인력으로 국내 최초 볼류메트릭 비디오 촬영 기술 개발한 인력으로 구성되어 있습니다. 세계 최초로 단일 3D 카메라 기반의 Full 3D 볼류메트릭 비디오촬영 기술을 개발하여 2020년 과기정통부 장관상을 수상했습니다.\n현재는 세계 최대의 혼합현실 콘텐츠 생성 스튜디오 네트워크를 구축하여 궁극적으로는 혼합현실 콘텐츠 플랫폼을 목표로 시장을 개척하고 있습니다. 저희 더블미와 함께할 창조적이며, 유능한 인재를 모십니다!",
        },
        devStyles: [{ name: "코드리뷰", description: "" }],
        welfares: [
            { name: "시차 출퇴근제", image: null },
            { name: "점심 식대 지원", image: null },
            { name: "간식 제공", image: null },
            { name: "건강검진 지원", image: null },
            { name: "상해보험 지원", image: null },
            { name: "사내 도서관 운영", image: null },
            { name: "명절 선물 제공", image: null },
            { name: "생일 선물 제공", image: null },
            { name: "각종 경조금 지원", image: null },
            { name: "경조휴가", image: null },
            { name: "내일채움공제", image: null },
            { name: "웰컴키트 제공", image: null },
        ],
    },
    {
        name: "차봇 모빌리티",
        registrationNumber: "5758700451",
        serviceLink: "https://www.chabot.co.kr",
        devTeam: {
            positions: [
                {
                    name: "프론트엔드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: [
                        "React",
                        "JavaScript",
                        "TypeScript",
                        "Flutter",
                        "Dart",
                        "jQuery",
                        "CSS",
                    ],
                },
                {
                    name: "백엔드 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 2,
                    skills: [
                        "Java",
                        "Spring / Spring Boot",
                        "NestJS",
                        "TypeScript",
                        "TypeORM",
                        "MySQL",
                        "Oracle",
                        "C#",
                    ],
                },
                {
                    name: "풀스택 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 2,
                    skills: [
                        "JavaScript",
                        "React",
                        "React Native",
                        "NestJS",
                        "TypeScript",
                        "TypeORM",
                        "MySQL",
                        "Oracle",
                        "jQuery",
                        "Java",
                        "Spring / Spring Boot",
                        "C#",
                        "CSS",
                    ],
                },
                {
                    name: "클라우드 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                    skills: [
                        "AWS",
                        "Spring / Spring Boot",
                        "Apache",
                        "Firebase",
                    ],
                },
                {
                    name: "보안 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                    skills: ["ISMS"],
                },
            ],
            description:
                "차봇 개발팀은 좋은 품질과 안정성 높은 모바일 애플리케이션을 개발하고 있습니다. 모르는게 있으면 동료에게 물어보고 함께 고민하여 해결하고 있습니다. 서비스의 문제를 해결할 수 있는 다양한 접근 방법을 함께 고민하고 기술로 풀어가며 적극적인 커뮤니케이션을 통해 함께 풀어갈 수 있는 분! 차봇과 함께해요 😊",
        },
        devStyles: [
            { name: "코드리뷰", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "익스트림 프로그래밍", description: "" },
        ],
        welfares: [
            { name: "개발장비 지원", image: null },
            { name: "시차 출퇴근제", image: null },
            { name: "인센티브제도", image: null },
            { name: "복지포인트 지급", image: null },
            { name: "차량 구입비 지원", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "건강검진 지원", image: null },
            { name: "각종 경조사 지원", image: null },
            { name: "장기근속자 포상+휴가", image: null },
            { name: "내일채움공제", image: null },
            { name: "웰컴키트 제공", image: null },
        ],
    },
    {
        name: "주식회사 빅크",
        registrationNumber: "5728602360",
        plan: "lightup",
        serviceLink: "https://www.bigc.im",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 3,
                    skills: [
                        "PHP",
                        "Laravel",
                        "PHPStorm",
                        "Git",
                        "Github",
                        "AWS",
                        "MySQL",
                        "ElasticSearch",
                    ],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 4,
                    rookie: 0,
                    junior: 2,
                    senior: 1,
                    leader: 1,
                    skills: ["JavaScript", "React", "Jest"],
                },
                {
                    name: "UX 디자이너",
                    total: 4,
                    rookie: 0,
                    junior: 1,
                    senior: 2,
                    leader: 1,
                    skills: ["Figma", "Sketch"],
                },
                {
                    name: "프로덕트 매니저",
                    total: 2,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 1,
                    //skills: ["Notion"],
                },
            ],
            description:
                "크리에이터 테크 스타트업 빅크는 국내 최고 R&D 크루들과 함께 합니다. 이미 두번 이상의 스타트업 개발 총괄 경력을 가지신 CTO님, 연쇄 창업과 멋진 서비스 개발 운영 경력을 가진 PO들, 그리고 국내외 다양한 서비스 개발 경험을 가진 개발 크루가 함께하고 있습니다. 저희는 빠르게 성장하는 크리에이터 이코노미 시장에서 함께 성장할 동료 개발자 분들을 모십니다. 크리에이터를 위한 올인원 플랫폼 빅크 스튜디오와 빅크 웹, 앱을 개발합니다.",
        },
        devStyles: [
            { name: "모닝 스크럼", description: "" },
            { name: "수평적 커뮤니케이션", description: "" },
            { name: "월 1회 티타임 피드백 세션", description: "" },
        ],
        welfares: [
            { name: "개발장비 지원", image: null },
            { name: "식사비 지원", image: null },
            { name: "인센티브제도", image: null },
            { name: "스톡옵션 제공(전직원 주주제)", image: null },
            { name: "외부 교육비 지원", image: null },
            { name: "도서 구입비 지원", image: null },
            { name: "건강검진 지원", image: null },
            { name: "경조사비 지원", image: null },
            { name: "커피, 음료, 간식 무제한", image: null },
        ],
    },
    {
        name: "주식회사 닷",
        registrationNumber: "3278700041",
        plan: "lightup",
        serviceLink: "https://www.dotincorp.com",
        devTeam: {
            positions: [
                {
                    name: "백엔드 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 2,
                    senior: 1,
                    leader: 0,
                    skills: [
                        "Java",
                        "Python",
                        "C++",
                        "Jenkins",
                        "Docker",
                        "AWS",
                        "MSA",
                    ],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 2,
                    senior: 1,
                    leader: 0,
                    skills: ["Vue.js", "Node.js"],
                },
                {
                    name: "모바일 엔지니어",
                    total: 2,
                    rookie: 0,
                    junior: 1,
                    senior: 1,
                    leader: 0,
                    skills: ["Swift", "Kotlin", "Flutter"],
                },
                {
                    name: "임베디드 엔지니어",
                    total: 3,
                    rookie: 0,
                    junior: 0,
                    senior: 2,
                    leader: 1,
                    skills: ["C", "C++", "Python"],
                },
            ],
            description:
                "닷은 서로를 먼저 믿습니다. 옳은 결과를 얻을 때까지 치열하게 계속 해나갑니다. 그리고 더 큰 소셜 임팩트를 위해 도전을 멈추지 않습니다. 또한 실수에서 배우며 새로운 역사를 창조합니다. 세상에는 그냥 하는 일과, 일생을 걸고 하는 일이 있습니다. 당신의 손길이 곳곳에 스며든, 절대로 타협할 수 없는, 닷과 함께 새로운 세상을 만들어가실 당신을 기다립니다.",
        },
        devStyles: [
            { name: "일일스크럼", description: "" },
            { name: "스프린트 리뷰", description: "" },
            { name: "코드리뷰", description: "" },
            { name: "데브옵스", description: "" },
            { name: "마이크로서비스", description: "" },
        ],
        welfares: [
            { name: "자율 출퇴근제도", image: null },
            { name: "도서 구입비 무제한 지원", image: null },
            { name: "생일 반차 및 맞춤형 기프티콘 지원", image: null },
            { name: "수요일 1:1 팀 식사", image: null },
            { name: "목요일 1시간 조기 퇴근", image: null },
            { name: "식대 지원", image: null },
            { name: "간식 지원", image: null },
        ],
    },
    {
        name: "(주)비트바이트",
        registrationNumber: "7058700940",
        plan: "lightup",
        serviceLink: "https://plkey.app/",
        devTeam: {
            positions: [
                {
                    name: "iOS 엔지니어",
                    total: 1,
                    rookie: 0,
                    junior: 1,
                    senior: 0,
                    leader: 0,
                    skills: ["Swift"],
                },
                {
                    name: "안드로이드 엔지니어",
                    total: 1,
                    rookie: 1,
                    junior: 0,
                    senior: 0,
                    leader: 0,
                    skills: ["Android Studio", "Kotlin"],
                },
                {
                    name: "백엔드 엔지니어",
                    total: 0,
                    rookie: 0,
                    junior: 0,
                    senior: 1,
                    leader: 0,
                    skills: ["Node.js", "MongoDB", "TypeScript"],
                },
                {
                    name: "프론트엔드 엔지니어",
                    total: 0,
                    rookie: 0,
                    junior: 0,
                    senior: 0,
                    leader: 0,
                    skills: ["React", "Vue.js", "Angular.js", "Typescript"],
                },
            ],
            description:
                "비트바이트가 빌딩 중인 개발조직은 총 5~6명 규모이며 Android/iOS 클라이언트 총 2~3명, 프론트엔드 1명, 웹 풀스택 1명으로 구성됩니다. 앱의 주요 기능을 웹뷰로 전환할 계획이 있어 각 클라이언트 개발자께서는 키보드 사용성 개선을 핵심 과업을 담당하게 되며, 웹프론트엔드 개발자께서는 합류 이후 웹뷰 전환 개발을 리딩합니다. 비트바이트가 지향하는 키보드는 언제나 '기본 키보드의 입력 경험과 동일한 수준', '사용자의 입력 편의를 극대화하는 서드파티 키보드' 입니다. 가령 iOS 키보드는 Android 키보드/삼성키보드가 제공하는 입력 외 부가기능을 비롯해 사용자가 자유롭게 커스텀할 수 있는 영역 또한 제한적이고, 여기서 서드파티 키보드의 필요가 발생합니다. 따라서 일반적인 서드파티 키보드의 필요와 저희 핵심 사용자층의 니즈에 따른 키보드의 심미적 커스텀 등을 위한 핵심 기능을 개발하고 유지보수하는 것이 중요한 과업입니다.",
        },
        devStyles: [
            { name: "애자일", description: "" },
            { name: "정기 스프린트 리뷰/회고", description: "" },
            { name: "기술 개선 스터디", description: "" },
        ],
        welfares: [
            { name: "유연근무(시차출퇴근제)", image: null },
            { name: "원격근무(주 2회 자율)", image: null },
            { name: "최신 개발장비 지원(MacBook M2)", image: null },
            { name: "식대 및 간식 제공", image: null },
            { name: "근속 및 명절선물 제공", image: null },
            { name: "경조사 지원", image: null },
        ],
    },
];
